import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AboutUs from './AboutUs';
import Home from './Home';
import Footer from './Footer';

const Layout = () => {
  return (
    <div>
      <Router>
        <nav
          className={' py-3 pb-6 border-gray-200 px-2 sm:px-4  bg-gray-800'}
        >
          <div className="container flex flex-wrap justify-between items-center mx-auto">
            
              <div className="flex text-white">
                Nom du garage
              </div>
          </div>
        </nav>

		
										<div className="flex flex-row justify-between py-1 space-x-10 scrollbar-hide snap-x snap-mandatory whitespace-nowrap overflow-scroll">
							
												
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/abarth.png" alt="abarth" />
									
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/alfa-romeo.png" alt="alfa-romeo"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/aston-martin.png" alt="aston-martin"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/audi.png" alt="audi"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/bentley.png" alt="bentley"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/bmw.png" alt="bmw"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/chery.png" alt="chery"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/chevrolet.png" alt="chevrolet"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/citroen.png" alt="citroen"/>
									
								
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/dacia.png" alt="dacia"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/dfsk.png" alt="dfsk"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/ds.png" alt="ds"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/ferrari.png" alt="ferrari"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/fiat.png" alt="fiat"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/ford.png" alt="ford"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/foton.png" alt="foton"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/gaz.png" alt="gaz"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/honda.png" alt="honda"/>
									
								
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/hyundai.png" alt="hyundai"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/isuzu.png" alt="isuzu"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/jaguar.png" alt="jaguar"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/jeep.png" alt="jeep"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/kia.png" alt="kia"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/lancia.png" alt="lancia"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/land-rover.png" alt="land-rover"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/lexus.png" alt="lexus"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/mahindra.png" alt="mahindra"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/mazda.png" alt="mazda"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/mercedes.png" alt="mercedes"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/mini.png" alt="mini"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/mitsubishi.png" alt="mitsubishi"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/nissan.png" alt="nissan"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/opel.png" alt="opel"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/peugeot.png" alt="peugeot"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/porsche.png" alt="porsche"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/renault.png" alt="renault"/>
									
								
								
											
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/seat.png" alt="seat"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/seres.png" alt="seres"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/skoda.png" alt="skoda"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/ssangyong.png" alt="ssangyong"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/suzuki.png" alt="suzuki"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/tata.png" alt="tata"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/toyota.png" alt="toyota"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/volkswagen.png" alt="volkswagen"/>
									
								
												
								
																	
										<img className="cursor-pointer transition duration-100 transform  hover:animate-bounce  "  width='100' src="https://www.moteur.ma/media/images/brands/thumbs/volvo.png" alt="volvo"/>
									
								
								
							</div>
							
			



    


        
          <Home  />
        <br />
        <hr></hr>
          <AboutUs />
        <Footer />
      </Router>
    </div>
  );
};

export default Layout;
